import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { FiMenu, FiX, FiGlobe } from 'react-icons/fi';

export default function Navbar() {
  const { t, lang, toggleLanguage } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: t('nav.home'), href: '#home' },
    { name: t('nav.services'), href: '#services' },
    { name: t('nav.team'), href: '#team' },
    { name: t('nav.pricing'), href: '#pricing' },
    { name: t('nav.contact'), href: '#contact' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-dark/95 backdrop-blur-md shadow-lg py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <a href="#home" className="text-2xl font-bold text-white tracking-tighter">
          Izzi<span className="text-blue-400">SEO</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link, idx) => (
            <a key={idx} href={link.href} className="text-gray-300 hover:text-white transition-colors text-sm font-medium">
              {link.name}
            </a>
          ))}
          
          <div className="flex items-center bg-white/10 rounded-full p-1 border border-white/20">
            <button onClick={() => toggleLanguage('en')} className={`px-3 py-1 rounded-full text-xs font-bold transition-all ${lang === 'en' ? 'bg-blue-500 text-white' : 'text-gray-400 hover:text-white'}`}>EN</button>
            <button onClick={() => toggleLanguage('el')} className={`px-3 py-1 rounded-full text-xs font-bold transition-all ${lang === 'el' ? 'bg-blue-500 text-white' : 'text-gray-400 hover:text-white'}`}>GR</button>
          </div>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white text-2xl" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-brand-dark border-t border-gray-800 p-6 flex flex-col space-y-4">
          {navLinks.map((link, idx) => (
            <a key={idx} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-gray-300 text-lg font-medium">
              {link.name}
            </a>
          ))}
          <div className="flex space-x-2 pt-4 border-t border-gray-800">
            <button onClick={() => { toggleLanguage('en'); setMobileMenuOpen(false); }} className={`px-4 py-2 rounded-md ${lang === 'en' ? 'bg-blue-500 text-white' : 'bg-gray-800 text-gray-300'}`}>English</button>
            <button onClick={() => { toggleLanguage('el'); setMobileMenuOpen(false); }} className={`px-4 py-2 rounded-md ${lang === 'el' ? 'bg-blue-500 text-white' : 'bg-gray-800 text-gray-300'}`}>Ελληνικά</button>
          </div>
        </div>
      )}
    </nav>
  );
}